import { render, staticRenderFns } from "./recent-articles.vue?vue&type=template&id=4138caf0&scoped=true"
import script from "./recent-articles.vue?vue&type=script&lang=js"
export * from "./recent-articles.vue?vue&type=script&lang=js"
import style0 from "./recent-articles.vue?vue&type=style&index=0&id=4138caf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4138caf0",
  null
  
)

export default component.exports